// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PaymentOptionsDto } from "@insite/client-framework/Types/ApiModels";
import { InfosBoxType } from "@store/Library/Components/Toolkit/InfosBox";
import { Draft } from "immer";

export interface InvoicePaymentDto {
    canPayOnline: boolean;
    invoicePaymentEnabled: boolean;
    accountDepositEnabled: boolean;
    accountDepositEnabledUntil: Date;
    accountDepositMaximum: number;
    balance: number;
    current: number;
    overdue: number;
    lastInvoiceDate: Date;
    lastPayDate: Date;
    lastPaymentAmount: number;
    termsDescription: string;
    credits: InvoicePaymentOption[];
    payments: InvoicePaymentOption[];
    paymentOptions: PaymentOptionsDto;
}

export interface InvoicePaymentOption {
    invoiceNumber: string;
    orderNumber: string;
    date: Date;
    type: string;
    customerPo: string;
    balanceDue: number;
    dateDue: Date;
    paymentAmount?: number;
    originalAmount?: number;
}

export interface EditableInvoicePaymentOption extends InvoicePaymentOption {
    isEditing: boolean;
}

export interface EditableInvoicePaymentDto extends Exclude<InvoicePaymentDto, "payments"> {
    payments: EditableInvoicePaymentOption[];
}

export interface AccountBalanceMessage {
    message: string;
    type: InfosBoxType;
}

export interface AccountBalanceState {
    accountBalance?: EditableInvoicePaymentDto;
    isSubmitting?: boolean;
    isLoading?: boolean;
    accountMessage?: AccountBalanceMessage;
}
const initialState: AccountBalanceState = {};

const actions = {
    "Pages/AccountBalance/SetIsLoading": (draft: Draft<AccountBalanceState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "Pages/AccountBalance/SetAccountBalanceMessage": (
        draft: Draft<AccountBalanceState>,
        action: { accountMessage: AccountBalanceMessage },
    ) => {
        draft.accountMessage = action.accountMessage;
    },
    "Pages/AccountBalance/LoadAccountBalance": (
        draft: Draft<AccountBalanceState>,
        action: { accountBalance: EditableInvoicePaymentDto | undefined },
    ) => {
        draft.accountBalance = action.accountBalance;
    },

    "Pages/AccountBalance/InvoiceEditableChecked": (
        draft: Draft<AccountBalanceState>,
        action: { invoiceNumber: string },
    ) => {
        const invoice = draft.accountBalance?.payments.find(o => o.invoiceNumber === action.invoiceNumber);
        if (invoice) {
            invoice.isEditing = !invoice.isEditing;
        }
    },
    "Pages/AccountBalance/UpdateInvoicePayment": (
        draft: Draft<AccountBalanceState>,
        action: { invoiceNumber: string; paymentAmount?: number },
    ) => {
        const invoice = draft.accountBalance?.payments.find(o => o.invoiceNumber === action.invoiceNumber);
        if (invoice) {
            invoice.paymentAmount = action.paymentAmount;
        }
    },
    "Pages/AccountBalance/ToggleSubmitting": (draft: Draft<AccountBalanceState>) => {
        draft.isSubmitting = !draft.isSubmitting;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type AccountBalanceActions = Parameters<typeof reducer>[1];
export default reducer;
